import * as React from 'react';
import { useEffect, useState } from 'react';
import { sessionStore, TCode, TFolderCodes } from '../../services';
import './folder-list.component.scss';

type TFolderList = {};
export const FolderList: React.FunctionComponent<TFolderList> = () => {
	const [activeCode, selectCode] = useState<string | undefined>(undefined);
	const [selectedList, selectList] = useState<TFolderCodes>({});
	const [list, initList] = useState<TFolderCodes>({});

	useEffect(() => {
		const subscription = sessionStore.listOfCodes$.subscribe((_codes: TFolderCodes) => {
			initList(_codes);
		});

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	useEffect(() => {
		sessionStore.selectedCodes$.next(selectedList);
		sessionStore.selectedCode$.next(activeCode);
	}, [activeCode, selectedList]);

	const setCode = (code: string, folder: string) => {
		const selected = { ...selectedList };
		if (selected[folder]) {
			const index = selected[folder].indexOf(code);
			if (index > -1) {
				selected[folder].splice(index, 1);
			} else {
				selected[folder].unshift(code);
			}
		} else {
			selected[folder] = [code];
		}
		selectList(selected);
		selectCode(code);
	};

	const setAllFolder = (folder: string) => {
		const selected = { ...selectedList };
		if (selected[folder] && selected[folder].length === list[folder].length) {
			selected[folder] = [];
		} else {
			selected[folder] = [...list[folder]];
		}
		selectList(selected);
		selectCode(selected[folder][0]);
	};

	return (
		<div className="container">
			{list && Object.keys(list).length ? (
				<ul>
					{Object.keys(list).map((folder, f_ind) => {
						return (
							<li
								key={`folder-${f_ind}`}
								className={
									selectedList[folder] && selectedList[folder].length === list[folder].length
										? 'selected'
										: undefined
								}>
								<p onClick={() => setAllFolder(folder)}>
									<span /> {folder}
								</p>
								<ul>
									{list[folder].map((code, c_ind) => (
										<li
											key={`folder-${f_ind}-qr-${c_ind}`}
											className={
												selectedList[folder] && selectedList[folder].indexOf(code) > -1
													? 'selected'
													: undefined
											}>
											<p
												className={activeCode === code ? 'active' : undefined}
												onClick={() => setCode(code, folder)}>
												<span /> QR {code}
											</p>
										</li>
									))}
								</ul>
							</li>
						);
					})}
				</ul>
			) : (
				<h3>Список пока пуст</h3>
			)}
		</div>
	);
};
